import { createSelector } from 'reselect';
import { IPayment } from '../../types/payment';
import { StoreState } from '../reducers';
export const Selector = (state: StoreState) => state.payments.data.list;
export const selectNamePayments = createSelector(Selector, (items): { label: string; value: number | string }[] => {
    const arrSel: { label: string; value: number | string }[] = [];

    items.forEach((item: IPayment) => {
        arrSel.push({ label: `${item.id}`, value: item.id });
    });

    return arrSel;
});
